
<template>
  <div>
    <DxDropDownBox
      v-model:value="gridBoxValue"
      v-model:opened="isGridBoxOpened"
      :defer-rendering="false"
      :display-expr="gridBoxDisplayExpr"
      :show-clear-button="true"
      :data-source="gridDataSource"
      value-expr="id"
      placeholder="Select a value..."
    >
      <template #content="{ data }">
        <DxDataGrid
          :columns="gridColumns"
          :data-source="gridDataSource"
          :show-borders="true"
          :showRowLines="true"
          :remote-operations="true"
          :hover-state-enabled="true"
          v-model:selected-row-keys="gridBoxValue"
          @selection-changed="onGridSelectionChanged($event)"
          height="100%"
        >
          <DxSelection mode="single" />
          <DxFilterRow :visible="true" />
          <DxGroupPanel :visible="true" />
          <DxGrouping :auto-expand-all="false" />
          <DxPaging :page-size="10" />
          <DxPager
            :visible="true"
            display-mode="full"
            :show-page-size-selector="false"
            :show-info="true"
            :show-navigation-buttons="true"
          />
        </DxDataGrid>
      </template>
    </DxDropDownBox>
  </div>
</template>
<script>
import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxGrouping,
  DxGroupPanel,
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import dxDropDownBox from "devextreme/ui/drop_down_box";
import axios from "axios";
import { getRecordById } from "./builder/base.js";
import DataSource from "devextreme/data/data_source";
export default {
  props: {
    rRoute: String,
    slug:String,
    
    returnType: {
      type: String,
      default: "",
      required: false,
    },
  },
  components: {
    DxDropDownBox,

    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
    DxGrouping,
    DxGroupPanel,
    DxPager,
    DataSource,
  },
  data() {
    return {
      selectedRecord:"",
      treeDataSource: null,
      treeBoxValue: null,
      getRecordById,
      gridDataSource: null,
      isGridBoxOpened: false,
      isTreeBoxOpened: false,
      gridBoxValue: [this.selectedRecord],
      treeViewRefName: "tree-view",
      gridColumns: ["name"],
      totalCount: 0,
    };
  },
  globalData: "hello",
  created() {},
  methods: {
    makeAsyncDataSource(rRoute, slug) {

      return new CustomStore({
        loadMode: "raw",
        key: "id",
        
        load: function (loadOptions) {
          let listurl = "/" + slug + "/" + rRoute + "/list";

          var parameters = {};

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          parameters.group = JSON.stringify(loadOptions.group);
          parameters.filter = JSON.stringify(loadOptions.filter);
          parameters.skip = loadOptions.skip;
          parameters.take = loadOptions.take;
          parameters.page =
            (parameters.skip + parameters.take) / parameters.take;
          var config = {
            params: parameters,
          };
          return axios
            .get(listurl, config)
            .then((response) => {
              return  response.data.results.data;
             
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey: function (key) {
          console.log("BY KEY ", key);

          if (key !=='') {
            let url = "/" + slug + "/" + rRoute + "/getById/" + key;

            getRecordById(url).then((response) => {
              //console.log("getRecordById Data", response.data.data.name);
            });
          }
         // return { id: key, name: "saurabh" };
        },
      });
    },

    gridBoxDisplayExpr(item) {
     // console.log("gridBoxDisplayExpr", item);
      return item && `${item.name} <${item.label}>`;
    },
    onTreeItemClick() {
      this.isTreeBoxOpened = false;
    },

    onGridSelectionChanged(item) {
      
      
      if(item.selectedRowsData.length >= 1)
      {
        this.selectedRecord = item.selectedRowsData[0].id;
        
          this.$emit("update:modelValue", item.selectedRowsData[0].id);
        
        
      }

      this.isGridBoxOpened = false;
    },

    setSelectedValue(key) {
      console.log("setSelectedValue", key);
    },
  },

  mounted() {
    this.gridDataSource = this.makeAsyncDataSource(this.rRoute, this.slug);
    //this.gridBoxValue  = "s6ee308190844c7bbc29e0e74dfc2857";
  },
};
</script>
<style scoped>
</style>